import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DATIQ_TOGGLE_ID, IDatiqCellHeaderSort } from '../models';
import { DatiqCellHeaderActions } from '../../../store';
import {
    DatiqAnalyticsInputInteraction,
    IDatiqAnalyticsEvent,
    IDatiqAnalyticsEventInputInfo,
} from '@dat/datiq-core/models';

@Injectable({
    providedIn: 'root',
})
export class DatiqCellHeaderEventsService {
    constructor(private _store: Store) {}

    getAnalyticsToggledOptionItem(
        settings: IDatiqCellHeaderSort
    ): IDatiqAnalyticsEvent {
        const inputInfo: IDatiqAnalyticsEventInputInfo = {
            inputId: DATIQ_TOGGLE_ID(settings.label),
            interaction: DatiqAnalyticsInputInteraction.Click,
            label: settings.label,
            settings: { ...settings },
            value: settings.sortBy,
        };

        return {
            eventName: DatiqCellHeaderActions.toggledOptionName,
            inputInfo,
        };
    }
}
